<template>
    <div id="verify-vignette" class="modal" tabindex="-1">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('verify_vignette_title') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <div class="icon icon-x"></div>
                    </button>
                </div>
                <div class="modal-body" ref="modalBody">
                    <iframe class="myIframe" frameborder="0" height="350" id="content" sandbox="allow-same-origin allow-downloads allow-scripts allow-forms" src="https://www.erovinieta.ro/vgncheck/" style="width:100%"></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Autocomplete from './Autocomplete.vue';
    import Heading from './Heading.vue';
    import { mapGetters } from 'vuex';

    export default {
        name: 'VerifyVignette',
        components: {
            Autocomplete,
            Heading
        },
        props: {
            value: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'auth/getLoginStatus',
                user: 'user/getUser',
                lang: 'language/getLanguage'
            })
        },
        data() {
            return {
                plateNo: '',
                email: '',
                chasisNo: '',
                btnText: this.$t('request_verify_vignette'),
                forceAdditionalInfo: false,
                message: '',
                errorMsgs: {
                    plateNo: '',
                    email: '',
                    chasisNo: ''
                },
                hideBtn: false
            }
        },
        mounted() {
            $('#verify-vignette').modal('show');

            $('#verify-vignette').on('hidden.bs.modal', () => {
                this.$emit('input', false);
            });

            if(this.isLoggedIn) {
                this.btnText = this.$t('btn_verify');
                this.email = this.user.email;
            }
            else {
                this.forceAdditionalInfo = true;
            }

            if(window.innerWidth <= 768) {
                this.$refs.modalBody.style.height = '65vh';
            }
        },
        watch: {
            forceAdditionalInfo(nVal) {
                if(nVal) {
                    this.btnText = this.$t('request_verify_vignette');
                }
            }
        },
        methods: {
            setSearchedVehicle(vehicle) {
                this.plateNo = vehicle._plateNo;
                this.chasisNo = vehicle._chasisNo;
            },

            validate() {
                let ok = true;

                let plateNoOk = this.validatePlateNo(this.plateNo, this.lang == 'ro' ? 1 : 0);

                if(!plateNoOk) {
                    ok = false;
                    this.errorMsgs.plateNo = this.$t('invalid_plate_number_message');
                }
                else {
                    this.errorMsgs.plateNo = '';
                }

                if(this.forceAdditionalInfo) {

                    if(!this.isEmailValid(this.email)) {
                        ok = false;
                        this.errorMsgs.email = this.$t('invalid_email');
                    }
                    else {
                        this.errorMsgs.email = '';
                    }

                    if(this.chasisNo.trim().length != 17) {
                        ok = false;
                        this.errorMsgs.chasisNo = this.$t('invalid');
                    }
                    else {
                        this.errorMsgs.chasisNo = '';
                    }
                }

                return ok;
            },

            async verifyVignette() {

                if(!this.validate()) {
                    return;
                }

                if(this.isLoggedIn && !this.forceAdditionalInfo) {
                    try {
                        let payload = {
                            'plateNo': this.plateNo
                        };

                        let response = await this.$axios.post('/vehicles/check-vehicle-vignettes', payload);

                        if(!response.data.exists) {
                            this.forceAdditionalInfo = true;
                            return;
                        }

                        this.message = this.$t('vignette_available_until') + response.data.expiryDate;
                        this.hideBtn = true;
                    }
                    catch(error) {
                        console.log(error);
                    }
                }
                else {
                    try {
                        let payload = {
                            '_plateNo': this.plateNo,
                            '_chasisNo': this.chasisNo,
                            'email': this.email
                        };

                        let response = await this.$axios.post('/vehicles/request-vignette-info', payload);

                        if(response.data.status) {
                            this.message = this.$t('you_will_be_contacted');
                            this.hideBtn = true;
                        }
                        else {
                            this.message = this.$t('error');
                        }
                    }
                    catch(error) {
                        console.log(error);
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal-title {
        font-size: 24px;
        font-weight: bold;
    }

    .modal-body {
        overflow-y: visible;
        height: auto;
        padding-left: 0px;
        padding-right: 0px;
    }

    .modal-footer {
        padding-left: 0px;
        padding-right: 0px;
        border-top: 0px;

        * {
            margin: 0px;
        }
    }
</style>
